import { render, staticRenderFns } from "./CellRendererDOB.vue?vue&type=template&id=412363fd&"
import script from "./CellRendererDOB.vue?vue&type=script&lang=js&"
export * from "./CellRendererDOB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports